/**
 * `initAuth()` — auth subsystem boot entry-point (T-007).
 *
 * Sits in its own module so the auth store (`auth-store.ts`) and the
 * refresh orchestrator (`features/auth/refreshOrchestrator.ts`) stay
 * decoupled at the import level — neither imports the other directly,
 * and this file is the only place that wires them together.
 *
 * Called from `src/main.tsx` AFTER `initGatewayClient()` +
 * `initAccountsClient()` (so any refresh fired immediately on resume
 * uses the configured base URLs) and BEFORE the React tree mounts
 * (so the first paint observes the resolved mode, not the empty
 * default).
 *
 * Idempotent — safe to call more than once. The orchestrator's
 * `startRefreshOrchestrator()` cancels any previous subscription /
 * timer before re-arming, so hot-reload during dev doesn't stack
 * stale timers.
 *
 * Returns the orchestrator teardown function. Tests use it to dispose
 * timers between cases; production never tears down.
 */

import { hydrateAuthFromStorage } from "./auth-store";
import { startRefreshOrchestrator } from "../features/auth/refreshOrchestrator";

export function initAuth(): () => void {
  hydrateAuthFromStorage();
  return startRefreshOrchestrator();
}
